import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MailIcon } from 'lucide-react';
import { StateScreen } from '../../components/StateScreen';
import { useLocale } from '../../contexts/LocaleContext';
import { useSession } from '../../contexts/SessionContext';

/**
 * MOB/Auth/AccountConfirmation.
 * REQUIRES BACKEND: email verification token and its validation.
 */
export function AccountConfirmation() {
  const {
    t
  } = useLocale();
  const navigate = useNavigate();
  const {
    signIn
  } = useSession();
  return <div className="min-h-screen w-full bg-sand pt-[max(12px,env(safe-area-inset-top))]" data-id="element-2351" data-mp="2bjg7bwujq1vq">
      <StateScreen tag={t('entry.confirm.tag')} title={t('entry.confirm.title')} body={t('entry.confirm.body')} points={[t('entry.confirm.p1'), t('entry.confirm.p2')]} icon={<MailIcon size={26} data-id="element-2353" data-mp="3rvllxse7jxed" />} primary={{
      label: t('entry.confirm.continue'),
      onClick: () => {
        signIn();
        navigate('/onboarding', {
          replace: true
        });
      }
    }} secondary={{
      label: t('entry.confirm.resend'),
      onClick: () => undefined
    }} data-id="element-2352" data-mp="2gh887gd64yc2" />
    </div>;
}